import React from 'react';
import { Statistic } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/views/statistic.less';

export default Statistic;
